import { colors } from '@/theme/colors';
import type { HeaderCellConfig } from '@/ui/table/table.types';

export const projectSuggestionsTableHeaders: HeaderCellConfig[] = [
  {
    columnKey: 'projects',
    bgColor: colors.basics.white,
    withSort: false,
    maxWidth: { xl: '19em', lg: '12em', md: '12em' },
  },
  {
    columnKey: 'type',
    maxWidth: { lg: '12em', md: '10em' },
    minWidth: { lg: '10em', md: '9em' },
  },
  {
    columnKey: 'tags',
    withSort: false,
    minWidth: { xl: '20em', lg: '11em', md: '10em' },
  },
  {
    columnKey: 'stage',
    withSort: false,
    maxWidth: { lg: '10em', md: '9em' },
  },
  {
    columnKey: 'createdFor',
    withSort: false,
    maxWidth: { xl: '8em', lg: '7em', md: '7em' },
  },
  {
    columnKey: 'status',
    bgColor: colors.basics.white,
    withSort: false,
  },
  {
    columnKey: 'lastModified',
    bgColor: colors.basics.white,
    withSort: false,
    width: { xl: '8%', lg: '8%', md: '8%' },
  },
  {
    columnKey: 'projectOwner',
    bgColor: colors.basics.white,
    withSort: false,
    width: { xl: '12%', lg: '8%', md: '9%' },
  },
];
